import * as React from 'react';
import settings from 'settings';
// import { connect } from 'react-redux'
// import { Dispatch } from 'redux'
import { FloaterOptionInterface, RootState } from 'types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AgentFloaterOptionInterface } from '../../types/FloaterOptionInterface';
import {
  floaterIgnoredCount,
  floaterIgnoredLast,
  floaterClosedLast,
  floaterShownSelector,
  rpPreviewModeSelector,
  floaterInviteIgnoredCountSelector,
  floaterInviteIgnoredLastSelector,
  floaterConfigSelector,
  floaterInviteClosedLastSelector,
  isCadillacSelector,
  webdeskPositionSelector,
  isWideSelector
} from '../../state/ui';
import { getDeviceType } from '../../utility';
import { pingAgentConversation } from '../../state/entities/conversations';

export interface Props {
  floaterShown: boolean;
  previewMode: string;
  inviteIgnoredCount: number;
  inviteIgnoredCountAction: (count: number | null) => void;
  inviteIgnoredLast?: number;
  inviteIgnoredLastAction: (time: number | null) => void;
  inviteClosedLast?: number;
  inviteClosedLastAction: (time: number | null) => void;
  inviteAcceptedAction: (message?: string) => void;
  floaterConfig: FloaterOptionInterface;
  isCadillac: boolean;
  position: string;
  isWide: boolean;
}

type StateProps = Pick<
  Props,
  | 'floaterShown'
  | 'previewMode'
  | 'inviteIgnoredCount'
  | 'inviteIgnoredLast'
  | 'inviteClosedLast'
  | 'floaterConfig'
  | 'isCadillac'
  | 'position'
  | 'isWide'
>;

const mapStateToProps = (state: RootState): StateProps => ({
  floaterShown: floaterShownSelector(state),
  previewMode: rpPreviewModeSelector(state),
  inviteIgnoredCount: floaterInviteIgnoredCountSelector(state),
  inviteIgnoredLast: floaterInviteIgnoredLastSelector(state),
  inviteClosedLast: floaterInviteClosedLastSelector(state),
  floaterConfig: floaterConfigSelector(state),
  isCadillac: isCadillacSelector(state),
  position: webdeskPositionSelector(state),
  isWide: isWideSelector(state)
});

type DispatchProps = Pick<
  Props,
  'inviteIgnoredCountAction' | 'inviteIgnoredLastAction' | 'inviteClosedLastAction' | 'inviteAcceptedAction'
>;

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  inviteIgnoredCountAction: count => dispatch(floaterIgnoredCount({ count })),
  inviteIgnoredLastAction: last => dispatch(floaterIgnoredLast({ last })),
  inviteClosedLastAction: last => dispatch(floaterClosedLast({ last })),
  inviteAcceptedAction: message => dispatch(pingAgentConversation({ pathId: 'agent', initialQuestion: message }))
});

interface ParentWindow extends Window {
  dasShowFloatingInvite?: (config: any) => void;
  dasInitialInvite: any;
  dasHideFloatingInvite?: () => void;
}

interface CustomWindow {
  parent: ParentWindow;
  inviteAccepted?: (text?: string) => void;
  inviteClosed?: () => void;
  inviteIgnored?: () => void;
  setTimeout: (handler: () => void, timeout: number) => number;
  clearTimeout: (handle: number) => void;
}

declare let window: CustomWindow;

const CLOSED_DEBOUNCE = 1000 * 60 * 60 * 24; // 1 day
const IGNORED_MAX = 3;
const IGNORED_DEBOUNCE = 1000 * 60 * 60; // 1 hour
const INITIAL_DELAY = process.env.NODE_ENV === 'development' ? 1000 : 1000 * 60; // 1 second dev / 1 minute prod
const REAPPEAR_DELAY = process.env.NODE_ENV === 'development' ? 1000 * 10 : 1000 * 60; // 10 seconds dev / 1 minutes prod

class Floater extends React.Component<Props> {
  private timerCallback: number | null = null;

  private isMobile = false;

  private floaterLoaded = false;

  private inviteClosedLast: number | undefined = undefined;

  private inviteIgnoredCount = 0;

  private inviteIgnoredLast: number | undefined = undefined;

  public componentDidMount() {
    this.isMobile = getDeviceType().toLowerCase() === 'mobile';
    this.inviteClosedLast = this.props.inviteClosedLast;
    this.inviteIgnoredCount = this.props.inviteIgnoredCount;
    this.inviteIgnoredLast = this.props.inviteIgnoredLast;

    if (this.inviteClosedLast) {
      if (this.inviteClosedLast + CLOSED_DEBOUNCE > Date.now()) {
        return;
      }
      if (this.inviteClosedLast) {
        this.inviteClosedLast = undefined;
        this.setState({ inviteClosedLast: null });
        this.props.inviteClosedLastAction(null);
      }
    }

    if (this.inviteIgnoredCount && this.inviteIgnoredLast && this.inviteIgnoredCount > 0) {
      if (this.inviteIgnoredLast + IGNORED_DEBOUNCE < Date.now()) {
        this.inviteIgnoredLast = undefined;
        this.inviteIgnoredCount = 0;
        this.setState({ inviteIgnoredCount: 0, inviteIgnoredLast: null });
        this.props.inviteIgnoredLastAction(null);
        this.props.inviteIgnoredCountAction(0);
      } else if (this.inviteIgnoredCount >= IGNORED_MAX) {
        return;
      }
    }

    this.timerCallback = window.setTimeout(() => {
      this.showFloatingInvite();
    }, INITIAL_DELAY);
  }

  public componentWillUnmount() {
    if (this.timerCallback) {
      window.clearTimeout(this.timerCallback);
    }
    if (window.parent.dasHideFloatingInvite) {
      window.parent.dasHideFloatingInvite();
    }
  }

  private showFloatingInvite(): void {
    const agentFloaterConfig = this.props.floaterConfig as AgentFloaterOptionInterface;
    if (
      (this.isMobile && (typeof agentFloaterConfig.mobile !== 'object' || !agentFloaterConfig.mobile.enabled)) ||
      (!this.isMobile && (typeof agentFloaterConfig.desktop !== 'object' || !agentFloaterConfig.desktop.enabled))
    ) {
      return;
    }

    if (!this.floaterLoaded) {
      if (this.isMobile) {
        window.parent.dasInitialInvite = {
          isCadillac: this.props.isCadillac,
          mobile: {
            isWide: this.props.isWide,
            launcherPosition: this.props.position,
            ...agentFloaterConfig.mobile
          }
        };
      } else {
        window.parent.dasInitialInvite = {
          isCadillac: this.props.isCadillac,
          desktop: agentFloaterConfig.desktop
        };
      }
      const s = document.createElement('script');
      s.setAttribute('type', 'text/javascript');
      s.setAttribute('src', `${settings.rootUrl}/floater.js`);
      window.parent.document.head.appendChild(s);
      this.floaterLoaded = true;
    } else {
      window.parent.dasShowFloatingInvite!({
        isCadillac: this.props.isCadillac,
        mobile: this.isMobile
          ? {
              isWide: this.props.isWide,
              launcherPosition: this.props.position,
              ...agentFloaterConfig.mobile
            }
          : undefined,
        desktop: !this.isMobile ? agentFloaterConfig.desktop : undefined
      });
    }
    this.setState({ floaterShown: true });
    window.inviteClosed = () => {
      const now = Date.now();
      this.inviteIgnoredCount = 0;
      this.inviteIgnoredLast = undefined;
      this.inviteClosedLast = now;
      this.setState({
        inviteIgnoredCount: 0,
        inviteIgnoredLast: null,
        inviteClosedLast: now
      });
      this.props.inviteIgnoredCountAction(0);
      this.props.inviteIgnoredLastAction(null);
      this.props.inviteClosedLastAction(now);
    };
    window.inviteIgnored = () => {
      this.inviteIgnoredCount++;
      this.inviteIgnoredLast = Date.now();
      this.setState({
        inviteIgnoredCount: this.inviteIgnoredCount,
        inviteIgnoredLast: this.inviteIgnoredLast
      });
      this.props.inviteIgnoredCountAction(this.inviteIgnoredCount);
      this.props.inviteIgnoredLastAction(this.inviteIgnoredLast);
      if (this.inviteIgnoredCount < IGNORED_MAX) {
        this.timerCallback = window.setTimeout(() => {
          this.showFloatingInvite();
        }, REAPPEAR_DELAY);
      }
    };
    window.inviteAccepted = text => {
      this.props.inviteAcceptedAction(text);
      window.parent.dasHideFloatingInvite!();
    };
  }

  // eslint-disable-next-line class-methods-use-this
  public render() {
    return false;
  }
}

export const FloaterContainer = connect(mapStateToProps, mapDispatchToProps)(Floater);
